import { Component } from '@angular/core';

@Component({
  selector: 'mc-error',
  template: `error page`,
})
export class ErrorPage {}
